import { Grid, IconButton, Typography } from '@mui/material';
import { formatCurrency } from '@/utils/string-utils';
import CloseIcon from '@mui/icons-material/Close';
import React, { FC, MouseEvent } from 'react';
import theme from '@/app/theme';

/**
 * The narrowest a panel may be drawn, in pixels. Below it the caption and the price run into the remove control.
 * A layout that cannot spare this much has to give the panel a row of its own,
 * so it sizes its columns from this rather than guessing.
 */
export const ATTACH_FILE_PANEL_MIN_WIDTH = 310;

/**
 * The box the preview is drawn in, in pixels, sized 4:3 at the row's own height.
 */
const PREVIEW_WIDTH = 64;
const PREVIEW_HEIGHT = 48;

interface Props {
  photoCost: number;
  thumbnail?: string;
  label?: string;
  onClear?: (e: MouseEvent<HTMLButtonElement>) => void;
  fullWidth?: boolean;
}

export const AttachFilePanel: FC<Props> = (props: Props) => {
  const { photoCost, thumbnail, label, onClear, fullWidth } = props;
  return (
    <Grid
      container={true}
      justifyContent={'space-between'}
      alignItems={'center'}
      sx={{
        background: theme.colors.grayBackground,
        borderRadius: '6px',
        minWidth: `${ATTACH_FILE_PANEL_MIN_WIDTH}px`,
      }}>
      <Grid item={true} xs={fullWidth}>
        <Grid container={true} alignItems={'center'}>
          <Grid item={true}>
            {thumbnail && (
              <img
                src={`data:image/jpeg;base64,${thumbnail}`}
                style={{
                  display: 'flex',
                  width: `${PREVIEW_WIDTH}px`,
                  height: `${PREVIEW_HEIGHT}px`,
                  objectFit: 'cover',
                  border: '1px solid ' + theme.colors.borderColor,
                  borderRadius: '6px 0px 0px 6px',
                }}
                alt={'attached-file'}
              />
            )}
          </Grid>
          <Grid item={true} ml={1}>
            <Typography variant={'body1'}>{`${label ?? 'Фото'} +${formatCurrency(photoCost, 0)}`}</Typography>
          </Grid>
        </Grid>
      </Grid>
      {onClear && (
        <Grid item={true} mr={1.5}>
          <IconButton disableRipple={true} onClick={onClear} aria-label={`Удалить ${label ?? 'фото'}`}>
            <CloseIcon color={'primary'} fontSize={'small'} sx={{ display: 'block' }} />
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
};

export default AttachFilePanel;
